export default __webpack_public_path__ + "static/media/Flag_of_Czech_Republic.01f884ca.svg";